import React from "react";
import PageShell from "../components/layout/PageShell";

export default function Ecole() {
  return (
    <PageShell
      title="L’École"
      subtitle="Cadre légal, mission, gouvernance, organisation académique et documents institutionnels."
    >
      {/* Présentation */}
      <section className="ema-block">
        <h2 className="ema-h3">Présentation</h2>
        <p className="ema-paragraph">
          L’École de la Magistrature (EMA) est une institution publique de formation judiciaire placée sous la tutelle du
          Ministère de la Justice et de la Sécurité Publique (MJSP). Elle assure la formation initiale et continue des
          magistrats, greffiers et acteurs de la Justice, en combinant enseignements, stages pratiques et exigences
          déontologiques.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Cadre légal */}
      <section className="ema-block">
        <h2 className="ema-h3">Cadre légal et statutaire</h2>
        <p className="ema-paragraph">
          Le cadre légal de l’EMA s’appuie notamment sur la Constitution haïtienne de 1987, ainsi que sur des textes
          structurants relatifs à l’organisation judiciaire et à la magistrature.
        </p>

        <ul className="ema-list" style={{ marginTop: 10 }}>
          <li>Arrêté du 2 juillet 1995 (désaffectation du local de l’Académie militaire)</li>
          <li>Décret du 22 août 1995 sur l’organisation judiciaire</li>
          <li>Loi créant le Conseil Supérieur du Pouvoir Judiciaire (13 septembre 2007)</li>
          <li>Loi relative à l’École de la Magistrature (15 novembre 2007)</li>
          <li>Loi portant statut de la magistrature (27 novembre 2007)</li>
        </ul>

        <div className="ema-inline-actions">
        </div>
      </section>

      <div className="ema-divider" />

      {/* Mission */}
      <section className="ema-block">
        <h2 className="ema-h3">Mission</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Ce que fait l’EMA</h3>
            <ul className="ema-list">
              <li>Assurer la formation initiale des élèves magistrats</li>
              <li>Organiser la formation continue des magistrats en fonction</li>
              <li>Contribuer au renforcement des capacités du système judiciaire</li>
              <li>Encadrer stages, évaluations et travaux pratiques</li>
              <li>Appuyer les concours et processus d’admission</li>
            </ul>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Valeurs</h3>
            <ul className="ema-list">
              <li>Rigueur et excellence académique</li>
              <li>Éthique et déontologie</li>
              <li>Respect des droits fondamentaux</li>
              <li>Professionnalisme et impartialité</li>
              <li>Service public de la justice</li>
            </ul>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Gouvernance / Structures */}
      <section className="ema-block">
        <h2 className="ema-h3">Gouvernance et structures</h2>
        <p className="ema-paragraph">
          L’EMA s’appuie sur une organisation institutionnelle assurant la gouvernance stratégique, administrative et pédagogique.
        </p>

        <div className="ema-grid-4" style={{ marginTop: 14 }}>
          <Card title="Conseil d’administration" text="Cadre de gouvernance stratégique (mise en place selon dispositif institutionnel)." />
          <Card title="Conseil de direction" text="Pilotage opérationnel, coordination et décisions de gestion." />
          <Card title="Direction des Études" text="Organisation académique, programmes, suivi pédagogique et évaluations." />
          <Card title="Équipe pédagogique" text="Une equipe de professeurs qualifiés et expérimentés." />
          <Card title="Jury de concours" text="Mobilisé selon les besoins, notamment pour les recrutements et sélections." />
          
        </div>
      </section>

      <div className="ema-divider" />

      {/* Organisation académique */}
      <section className="ema-block">
        <h2 className="ema-h3">Organisation académique</h2>
        <p className="ema-paragraph">
          La formation combine cours, stages en juridictions, regroupements pédagogiques et exercices pratiques (simulations d’audience,
          rédaction, cas pratiques).
        </p>

        <div className="ema-inline-actions" style={{ marginTop: 12 }}>
          <a className="ema-btn ema-btn-secondary" href="/documents/formation-initiale.pdf" target="_blank" rel="noreferrer">
            Programme formation initiale
          </a>
          <a className="ema-btn ema-btn-ghost" href="/documents/calendrier-formation-2025-2027.pdf" target="_blank" rel="noreferrer">
            Calendrier 2025–2027
          </a>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Section premium : Timeline */}
      <section className="ema-block">
        <h2 className="ema-h3">Repères & évolution</h2>
        <div className="ema-timeline" style={{ marginTop: 14 }}>
          <Timeline n="1987" title="Fondement constitutionnel" text="Cadre de référence institutionnel." />
          <Timeline n="1995" title="Structuration et installation" text="Textes et organisation initiale." />
          <Timeline n="2007" title="Renforcement institutionnel" text="Lois majeures : CSPJ, EMA, statut de la magistrature." />
          <Timeline n="Aujourd’hui" title="Modernisation" text="Déploiement de la formation et appui numérique (campus/Moodle)." />
        </div>
      </section>
    </PageShell>
  );
}

function Card({ title, text }) {
  return (
    <div className="ema-card">
      <h3 className="ema-card-title">{title}</h3>
      <p className="ema-card-text">{text}</p>
    </div>
  );
}

function Timeline({ n, title, text }) {
  return (
    <div className="ema-step">
      <div className="ema-step-num ema-step-num-wide">{n}</div>
      <div className="ema-step-body">
        <h3 className="ema-h3" style={{ margin: 0 }}>{title}</h3>
        <p className="ema-paragraph" style={{ marginTop: 10 }}>{text}</p>
      </div>
    </div>
  );
}
